import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React from 'react';

// COMPONENTS
import Loader from '../../common/Loader';
import TariffingListItem from './TariffingTableRow';

const TariffingTable = ({
  tariffSchemes = [],
  showSingleTariffScheme,
}) => {
  const generateTable = () => {
    if (tariffSchemes.length > 0) {
      return (
        <TableContainer
          sx={{ marginBottom: 4, overflowX: 'auto', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tariffSchemes.map((scheme) => (
                <TariffingListItem
                  key={scheme.tariff_scheme_id}
                  id={scheme.tariff_scheme_id}
                  schemeName={scheme.tariff_scheme_name}
                  schemeType={scheme.scheme_type_name}
                  schemeStatus={scheme.scheme_status_name}
                  scheme={scheme}
                  onClickName={showSingleTariffScheme}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }

    return <Loader />;
  };

  return generateTable();
};

export default TariffingTable;
